<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<v-form ref="form">
					<personal-information-fields
						ref="personalInformationFields"
						v-model:model-value="personalInformationData"
					/>
					<complaint-description
						ref="complaintDescriptionFields"
						v-model:model-value="complaintDescriptionData"
					/>

					<v-row>
						<v-spacer />
						<v-col cols="auto">
							<v-btn
								color="primary"
								@click="submit()"
							>
								<translate>Submit</translate>
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
			</div>
		</div>
	</div>
</template>

<script>

import {
	axios,
} from '../../services/axios-service.js';
import {
	inform,
} from 'laravel-front-library';

export default {
	name: 'ComplaintsForm',
	props: {
		csrfToken: {
			type: String,
			required: true,
		}
	},
	data () {
		return {
			personalInformationData: {
				gender: null,
				initials: '',
				infix: '',
				lastName: '',
				phoneNumber: '',
				email: '',
			},

			complaintDescriptionData: {
				policyNumber: ' ',
				device: ' ',
				complaintFullReason: '',
				complaintDescription: '',
				offeredSolutionText: '',
				complaintWantedSolution: '',
				attachment: null,
			}
		};
	},

	methods: {
		/**
		 * Checks whether all required form information is filled in
		 *
		 * @returns {boolean}
		 */
		validate () {
			const first = this.$refs.personalInformationFields.validate();
			const second = this.$refs.complaintDescriptionFields.validate();

			return first && second;
		},

		/**
		 * Submit the complaints form
		 *
		 * @returns {void}
		 */
		submit () {
			if (this.validate()) {
				const formData = new FormData();

				formData.append('gender', this.personalInformationData.gender);
				formData.append('initials', this.personalInformationData.initials);
				formData.append('infix', this.personalInformationData.infix);
				formData.append('lastName', this.personalInformationData.lastName);
				formData.append('phoneNumber', this.personalInformationData.phoneNumber);
				formData.append('email', this.personalInformationData.email);

				formData.append('policyNumber', this.complaintDescriptionData.policyNumber);
				formData.append('device', this.complaintDescriptionData.device);
				formData.append('complaintReason', this.complaintDescriptionData.complaintFullReason);
				formData.append('complaintDescription', this.complaintDescriptionData.complaintDescription);
				formData.append('offeredSolution', this.complaintDescriptionData.offeredSolutionText);
				formData.append('wantedSolution', this.complaintDescriptionData.complaintWantedSolution);
				formData.append('csrfToken', this.csrfToken);

				if (this.complaintDescriptionData.attachment !== null) {
					formData.append('attachment', this.complaintDescriptionData.attachment[0]);
				}

				axios
					.post('/complaints', formData, {
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					})
					.then(() => {
						inform(this.$gettext('Complaint submitted'));
						window.location.href = '/complaints';
					})
					.catch((error) => {
						window.captureException(error);
					});
			}
		}
	}
};
</script>
